import React from 'react';
import {usePropertyField} from "./usePropertyField";
import {Col, Form, Row} from "react-bootstrap";
import {conformValue} from "../helpers";
import ClearIndicator from "../../../components/common/horizontal-form-inputs/ClearIndicator";
import DropdownIndicator from "../../../components/common/horizontal-form-inputs/DropdownIndicator";
import classNames from "classnames";
import Select from "react-select";

const PredefinedOptionsAddField = ({property, controlId, readOnly, expanded, options}) => {
    const {field, invalid, error, isInFlight, handleOnChange, mask} = usePropertyField(controlId, property);
    return expanded && (
        <Form.Group as={Row} className={"mb-1"} controlId={controlId + "." + property.propertyName}>
            <Form.Label column xs={7} sm={3}>{property.propertyName}</Form.Label>
            <Col>{readOnly ?
                <Form.Control
                    value={field.value === null ? "" : conformValue(field.value, mask)}
                    size={"sm"}
                    disabled
                    plaintext
                />
                :
                <Select
                    placeholder={"Select..."}
                    options={options}
                    isSearchable
                    inputId={controlId + "." + property.propertyName}
                    components={{ClearIndicator, DropdownIndicator}}
                    className={classNames({'is-invalid': invalid})}
                    classNamePrefix={"react-select"}
                    styles={{
                        control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: invalid ? "#e63757!important" : 'var(--falcon-input-border-color)'
                        })
                    }}
                    onChange={(e) => {
                        handleOnChange(e)
                    }}
                    isLoading={isInFlight}
                    value={{
                        value:field.value,
                        label:options.find((o) => {return o.value === field.value})?.label
                    }}
                />}
                {invalid && <Form.Control.Feedback type={"invalid"}>{error.message}</Form.Control.Feedback>}
            </Col>
        </Form.Group>
    )
}
export default PredefinedOptionsAddField